import React from 'react';
import ErrorBoundary from '../../components/ErrorBoundaries/ErrorBoundary';
import { v4 as uuidv4 } from 'uuid';

import HomeCarousel from '../../../own-days/CommonComponents/HomeCarousel/HomeCarousel';
import TwoCategory from '../../../own-days/Desktop/HomeComponents/TwoCategory/TwoCategory';
import ODHomeBestSellers from '../../../own-days/Desktop/HomeComponents/ODHomeBestSellers/ODHomeBestSellers';
import ODHomePickShapeV2 from '../../../own-days/Desktop/HomeComponents/ODHomePickShapeV2/ODHomePickShapeV2';
import HomeTitleAndDescription from '../../../own-days/Desktop/HomeComponents/HomeTitleAndDescription/HomeTitleAndDescription';
import ODHomeMostPopularBrands from '../../../own-days/Desktop/HomeComponents/ODHomeMostPopularBrands/ODHomeMostPopularBrands';
import HomeStoreSection from '../../../own-days/Desktop/HomeComponents/HomeStoreSection/HomeStoreSection';
import InformationHome from '../../../own-days/CommonComponents/InformationHome/InformationHome';
import LatestCampaigns from '../../../own-days/CommonComponents/LatestCampaigns/LatestCampaigns';
import OwndaysTips from '../../../own-days/CommonComponents/OwndaysTips';
import Outlet from '../../../own-days/CommonComponents/Outlet';

import './BannerAndCarouselRenderer.scss';
import OdWelcome from '../../../own-days/CommonComponents/OdHome/OdWelcome/OdWelcome';
import OdCategoryTab from '../../../own-days/CommonComponents/OdHome/OdCategoryTab/OdCategoryTab';
import OdCatCollection from '../../../own-days/CommonComponents/OdHome/OdCatCollection/OdCatCollection';
import OdColHighlight from '../../../own-days/CommonComponents/OdHome/OdColHighlight/OdColHighlight';
import OdServices from '../../../own-days/CommonComponents/OdHome/OdServices/OdServices';
import OdTips from '../../../own-days/CommonComponents/OdHome/OdTips/OdTips';
import OdInformation from '../../../own-days/CommonComponents/OdHome/OdInformation/OdInformation';

const componentMapping = {
  TOP_CAROUSEL_SECTION: comp => <HomeCarousel banners={comp.categories} />,
  TYPE_WELCOME: comp => <OdWelcome data={comp} />,
  TYPE_CATEGORY_TAB: comp => <OdCategoryTab data={comp} />,
  TYPE_CATEGORY_EYEGLASSES: comp => <OdCatCollection data={comp} />,
  TYPE_CATEGORY_SUNGLASSES: comp => <OdCatCollection data={comp} />,
  TYPE_COLLECTION: comp => <OdColHighlight data={comp} />,
  TYPE_SERVICES: comp => <OdServices data={comp} />,
  TYPE_TIPS: comp => <OdTips data={comp} />,
  TYPE_INFORMATIONS: comp => <OdInformation data={comp} />,
  // OLD Components
  TYPE_TWO_CATEGORY: comp => <TwoCategory categories={comp.categories} />,
  TYPE_BEST_SELLERS: comp => (
    <ODHomeBestSellers
      button={comp.button}
      catId={comp.data?.catId}
      description={comp.description}
      title={comp.title}
    />
  ),
  FOR_HIM_FOR_HER: comp => <TwoCategory categories={comp.categories} />,
  TYPE_PICK_YOUR_SHAPE: comp => <ODHomePickShapeV2 shapes={comp.shapes} title={comp.heading} />,
  OUR_BRAND_AND_COLLECTION_HEADING: comp => <HomeTitleAndDescription data={comp} />,
  TYPE_MOST_POPULAR_BRANDS: comp => (
    <ODHomeMostPopularBrands
      brands={comp.brands}
      device="desktop"
      title={comp.heading}
      viewAllBtn={comp?.viewAllBtn}
    />
  ),
  TYPE_FIND_STORE_NEAR_YOU: comp => <HomeStoreSection data={comp} />,
  TYPE_BOOK_YOUR_FREE_EYE_TEST: comp => <HomeStoreSection data={comp} />,
  TYPE_INFORMATION: () => <InformationHome />,
  TYPE_LATEST_CAMPAIGNS: () => <LatestCampaigns />,
  TYPE_OWNDAYS_TIPS: () => <OwndaysTips />,
  TYPE_OUTLET: () => <Outlet />,
};

const BannerAndCarouselRenderer = ({ componentsData }) => {
  const renderComponent = comp => {
    const Component = componentMapping[comp.type];
    return Component ? <ErrorBoundary key={uuidv4()}>{Component(comp)}</ErrorBoundary> : null;
  };

  const renderHomePage = item => {
    return item.data.map((comp, idx) => (
      <React.Fragment key={idx}>{renderComponent(comp)}</React.Fragment>
    ));
  };

  return (
    <div className="component">
      {componentsData &&
        componentsData.map((item, idx) => (
          <div
            key={idx}
            className={`section-component ${item?.blockSpace ? 'section-component--space' : ''}`}
          >
            {renderHomePage(item)}
          </div>
        ))}
    </div>
  );
};

export default BannerAndCarouselRenderer;
